export const AGREEMENT_LABELS = {
  SERVICE_TERMS: '서비스 이용약관 (필수)',
  SERVICE_POLICY: '서비스 운영정책 (필수)',
} as const;

export type AgreementKey = keyof typeof AGREEMENT_LABELS;
